import { createContext, useCallback, useContext, useRef } from 'react';
import { string as stringUtil } from '@eti/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const TranslationContext = /*#__PURE__*/createContext({
  translations: {},
  options: {}
});
const TranslationProvider = _ref => {
  let {
    translations = {},
    options = {
      clearCache: false
    },
    children
  } = _ref;
  return /*#__PURE__*/_jsx(TranslationContext.Provider, {
    value: {
      translations,
      options
    },
    children: children
  });
};
const debugTextResolver = JSON.parse(sessionStorage.getItem('debugTextResolver') || '{}');
export const getTranslation = (key, translations, warnedKeys) => {
  const translation = key && translations[key];
  const wasWarned = typeof key === 'string' && warnedKeys.has(key);
  if (debugTextResolver.warnNotFoundKeys && !translation && !wasWarned) {
    // eslint-disable-next-line no-console
    console.warn(`Translation not found for key: ${key}`);
    warnedKeys.add(key || '');
  }
  if (debugTextResolver.alwaysUseKeys || debugTextResolver.useKeyWhenTextNotFound && !translation) {
    return key;
  }
  return translation || '';
};
const useTranslation = () => {
  const context = useContext(TranslationContext);
  if (!context) {
    throw new Error('useTranslation must be used within a TranslationProvider');
  }
  const {
    translations
  } = context;
  const warnedKeys = useRef(new Set());
  const t = useCallback(function (key) {
    for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      params[_key - 1] = arguments[_key];
    }
    return params.length === 0 ? getTranslation(key, translations, warnedKeys.current) : stringUtil.insertArgument(getTranslation(key, translations, warnedKeys.current), ...params);
  }, [translations]);
  const nonDebugT = useCallback(function (key) {
    const translationKey = getTranslation(key, translations, warnedKeys.current);
    for (var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      params[_key2 - 1] = arguments[_key2];
    }
    return params.length === 0 ? translationKey : stringUtil.insertArgument(translationKey, ...params);
  }, [translations]);
  return {
    t,
    nonDebugT
  };
};
export { TranslationProvider, useTranslation };
//# sourceMappingURL=TranslationContext.js.map